import { render, staticRenderFns } from "./deleteMainCategoryProduct.vue?vue&type=template&id=60f98f00&scoped=true"
import script from "./deleteMainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./deleteMainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./deleteMainCategoryProduct.vue?vue&type=style&index=0&id=60f98f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f98f00",
  null
  
)

export default component.exports